<form *ngIf="fieldsActionForm">

  <div class="row">
    <div class="col-12">
      <p>Para Seleccionar más de un campo de acción , por favor mantenga la tecla <strong>Ctrl</strong> y seleccione los
        campos que desea agregar.</p>
    </div>
  </div>

  <hr/>
  <div *ngIf="soloLecturaCamposAccion==false">
    <div class="row" *ngFor="let item of relationProfilesFieldsOfAction; let i = index">

      <div class="col-6" *ngIf="isLegalPerson==false">
        <div class="colum_left">
          <p>Perfiles</p>
          <select class="form-select" aria-label="Default select example"
                  name="perfilesNatural_{{i}}"
                  [(ngModel)]="item.idProfil"
                  id="perfilesNatural_{{i}}"
                  (change)="getFieldsOfActionByProfile(item)">
            <option value="" selected disabled>Seleccionar</option>
            <option *ngFor="let perfil of listaPerfilesNaturalPerson"
                    [value]="perfil.id">{{perfil.description}}</option>
          </select>
        </div>
      </div>

      <div class="col-6" *ngIf="isLegalPerson==true">
        <div class="colum_left">
          <p>Dirección o Sede:</p>
          <input type="text" class="form-control"
                 name="direccionSede_{{i}}"
                 [(ngModel)]="item.address"
          />
        </div>
      </div>

      <div class="col-6">
        <div class="colum_right">
          <p>Campos de acción</p>

          <select *ngIf="isLegalPerson==false"
                  class="form-select" multiple aria-label="multiple select example"
                  name="camposAccionNatural_{{i}}"
                  [(ngModel)]="item.idfieldsOfAction">
            <option *ngFor="let campoAccionActual of item.fieldsAction"
                    [value]="campoAccionActual.id">{{campoAccionActual.description}}</option>
          </select>

          <select *ngIf="isLegalPerson==true"
                  class="form-select" multiple aria-label="multiple select example"
                  name="camposAccionLegal_{{i}}"
                  [(ngModel)]="item.idfieldsOfAction">
            <option *ngFor="let campoAccionLegalActual of listCamposDeAccionLegalPerson"
                    [value]="campoAccionLegalActual.id">{{campoAccionLegalActual.description}}</option>
          </select>

        </div>
      </div>
      <p></p>
    </div>
  </div>

  <div *ngIf="soloLecturaCamposAccion==true">
    <div class="row" *ngFor="let item of relationProfilesFieldsOfAction; let i = index">
      <div class="col-6">
        <div class="colum_left">
          <p *ngIf="isLegalPerson==false">Perfiles</p>
          <p *ngIf="isLegalPerson==true">Dirección o Sede:</p>
          <input type="text" class="form-control"
                 name="description_{{i}}"
                 disabled
                 [(ngModel)]="item.description"/>
        </div>
      </div>
      <div class="col-6">
        <div class="colum_right">
          <p>Campos de acción</p>
          <select class="form-select" multiple aria-label="multiple select example"
                  name="camposAccion_{{i}}"
                  disabled
                  [(ngModel)]="item.fieldsOfActions">
            <option *ngFor="let campoAccionActual of item.fieldsOfActions">{{campoAccionActual}}</option>
          </select>
        </div>
      </div>
      <p></p>
    </div>
  </div>

  <div class="row" *ngIf="soloLecturaCamposAccion==false">
    <div class="col-12">
      <button class="btn btn-success" (click)="add()">
        Agregar Perfil
      </button>
      <button class="btn btn-danger delete" (click)="remove()">
        Quitar Perfil
      </button>
      <button class="btn btn-info" style="margin:20px" (click)="guardarPerfiles(true)">
        Guardar perfiles
      </button>
    </div>
  </div>
</form>
